import React, { useCallback, useState } from 'react';
import { MotionConfig } from 'framer-motion';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Transformation } from './components/Transformation';
import { Services } from './components/Services';
import { PoolProblems } from './components/PoolProblems';
import { Process } from './components/Process';
import { Gallery } from './components/Gallery';
import { WhyInnova } from './components/WhyInnova';
import { ServiceArea } from './components/ServiceArea';
import { Reviews } from './components/Reviews';
import { LeadForm } from './components/LeadForm/LeadForm';
import { Footer } from './components/Footer';
import { MobileActionBar } from './components/MobileActionBar';
import type { EstimatePrefill, ServiceOption } from './types/content';
export function App() {
  const [prefill, setPrefill] = useState<EstimatePrefill>({
    nonce: 0
  });
  const requestEstimate = useCallback((opts: {
    service?: ServiceOption;
    note?: string;
  }) => {
    setPrefill({
      ...opts,
      nonce: Date.now()
    });
    requestAnimationFrame(() => document.getElementById('estimate')?.scrollIntoView({
      behavior: 'smooth'
    }));
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3rd18nfm3z7mg">
      <div className="min-h-full w-full bg-white" data-id="element-1" data-mp="5opww5kum4f">
        <Header data-id="element-2" data-mp="56mnfkhz7n0" />
        <main data-id="element-3" data-mp="7sulgbavp5r">
          <Hero data-id="element-4" data-mp="2zl3cxocsjc6w" />
          <TrustBar data-id="element-5" data-mp="2zlld2w2kqak3" />
          <Transformation data-id="element-6" data-mp="2zmepodo7rua5" />
          <Services onRequestEstimate={service => requestEstimate({
          service
        })} data-id="element-7" data-mp="2zmwl5831y4h0" />
          <PoolProblems onRequestEstimate={note => requestEstimate({
          note
        })} data-id="element-8" data-mp="33n6y54p9hv5d" />
          <Process data-id="element-9" data-mp="38kqau06b9zv7" />
          <Gallery data-id="element-10" data-mp="38k6x6vnp1xmz" />
          <WhyInnova data-id="element-11" data-mp="38o4fxg6d0n6c" />
          <ServiceArea data-id="element-12" data-mp="3dkl5met7j9lj" />
          <Reviews data-id="element-13" data-mp="3dlw6o6v9q38y" />
          <LeadForm prefill={prefill} data-id="element-14" data-mp="3dmfqjt4hb1pm" />
        </main>
        <Footer data-id="element-15" data-mp="nvssr1axyhud" />
        <MobileActionBar data-id="element-16" data-mp="nwc1brepbtvq" />
      </div>
    </MotionConfig>;
}